import { fromError } from "zod-validation-error";
//#region src/validators/parse.ts
var parseFactory = (schema) => (raw) => {
	const result = schema.safeParse(raw);
	return result.success ? {
		success: true,
		data: result.data
	} : {
		success: false,
		error: fromError(result.error),
		raw
	};
};
//#endregion
export { parseFactory };

//# sourceMappingURL=parse.js.map